import { Map } from "immutable";
import * as React from "react";
import { ApiResult } from "../../../Shared/api/apiTypes";
import { errorText, getReports, loadingText, noResultsText } from "../../custom_api/api";
import { Report } from "../../custom_models/report";
import { Jumbo } from "../components/jumbo";
import { BasePageProps } from "../components/page_renderer";
import { TeaserProps, Teasers } from "../components/teaser";

export interface ReportOverviewPageProps extends BasePageProps {
  readonly kind: "reportOverview"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly phImageUrlSmall?: string
  readonly phImageUrl: string
  readonly phImageUrlLarge: string
  readonly imageAlt: string
  readonly buttonUrl: string
  readonly buttonTitle: string
  readonly jumboSize: "small" | "large"
}

export interface ReportOverviewPageState {
  reports: ApiResult<Map<string, Report>>
}

const reportOverviewPageStateZero: ReportOverviewPageState = {
  reports: "loading",
}

export class ReportOverviewPage extends React.Component<ReportOverviewPageProps, ReportOverviewPageState> {
  constructor(props: ReportOverviewPageProps) {
    super(props)

    this.state = reportOverviewPageStateZero
  }

  componentDidMount() {
    if (this.state.reports == "loading") {
      getReports().then(reports =>
        this.setState((s, _) => reports !== "loading" && reports !== "error" ? ({ ...s, reports }) : s)
      )
    }

    document.title = this.props.pageTitle
  }

  render() {
    const reports = (
      <section className="reports">
        {this.state.reports == "loading"
          ? (
            <div className="container--m align--center text--styled">
              <p className="weight--bold container--s">{loadingText}</p>
            </div>
          )
          : this.state.reports == "error"
          ? (
            <div className="container--m align--center text--styled">
              <p className="weight--bold container--s">{errorText}</p>
            </div>
          )
          : this.state.reports.isEmpty()
          ? (
            <div className="container--m align--center text--styled">
              <p className="weight--bold container--s">{noResultsText}</p>
            </div>
          ) : <Teasers
              items={this.state.reports.map<TeaserProps>((r, k) => ({
                key: `report-overview-item-${k}`,
                headingLevel: 'h2',
                title: r.title,
                intro: r.shortDescription,
                label: r.datetimes.count() == 1 
                  ? <time dateTime={r.datetimes.first().format("L")}>
                      {r.datetimes.first().format("L")}
                    </time>
                  : null,
                linkUrl: r.url,
                imageUrl:r.imageUrl,
                imageUrlLarge:r.imageUrlLarge,
                imageAlt: r.imageAlt,
                locationFooter: r.locations.count() == 1 ? r.locations.first() : 'Meerdere locaties'
              })).toList()}
            />
        }
      </section>
    )

    return (
      <>
        <Jumbo
          title={this.props.headerTitle}
          contents={this.props.description}
          imageUrlSmall={this.props.jumboSize == 'small' && this.props.phImageUrlSmall ? this.props.phImageUrlSmall : undefined}
          imageUrl={this.props.phImageUrl}
          imageUrlLarge={this.props.phImageUrlLarge}
          imageAlt={this.props.imageAlt}
          buttonUrl={this.props.buttonUrl}
          buttonTitle={this.props.buttonTitle}
          size={this.props.jumboSize}
        />
        <div className="container--lg align--center" aria-live="polite">{reports}</div>
      </>
    )
  }
}

{/* TH: Added to styleguide! */}
